
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { BaseProfileDataInterface } from '@/services/Users-profile/interfaces';

@Component({
  mixins: [
    Themeable,
  ],
})
export default class DeleteFeedbackDialog extends Vue {

  private visible: boolean = false;

  private created(): void {
    this.visible = true;
  }

  private get message(): string {
    return `Are you sure ?`;
  }

  private deleteFeedback(): void {
    this.$emit('delete-feedback');
    this.destroyComponent();
  }

  private destroyComponent(): void {
    this.$emit('close');
  }
}
